<script lang="ts">
	import Translation from '../../utils/Translation.svelte'
	import type { TranslationKey } from '../../utils/translation.js'

	export let title: TranslationKey
</script>

<section class="footer-section">
	<div class="title">
		<Translation key={title} />
	</div>
	<div class="content">
		<slot />
	</div>
</section>

<style>.footer-section {
  display: flex;
  width: 100%;
  flex-direction: column;
}
@media screen and (min-width: 640px) {
  .footer-section {
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
}

.title {
  font-size: 14px;
  font-weight: 600;
}

.content {
  display: flex;
  flex-direction: column;
}
@media screen and (min-width: 640px) {
  .content {
    gap: 12px;
    flex-direction: row;
  }
}</style>
